var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ 
    backgroundImage: 'url(' + _vm.bg + ')',
    backgroundPosition: 'center'
  })},[_c('profile-header'),_vm._v(" "),_c('v-container',{attrs:{"fill-height":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('registration',{attrs:{"apiUrl":_vm.apiUrl}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ac2eb37","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/index.vue
// module id = 332
// module chunks = 1